module.exports = __webpack_public_path__ + "img/home.4ccd24a7.png";